import {useContext} from 'react'

import PropTypes from 'prop-types'

import {atomToastAutoCloseTimes} from '@s-ui/react-atom-toast'
import Context from '@s-ui/react-context'

import SearchSaveNotification, {SEARCH_SAVE_NOTIFICATION_TYPES} from './search-save-notification.js'

const SearchSaveErrorNotification = ({
  show,
  onClose = () => {},
  isMinimumFiltersAppliedError,
  portalContainer,
  className
}) => {
  const {i18n} = useContext(Context)

  const text = isMinimumFiltersAppliedError
    ? i18n.t('ADD_FILTER_TO_CREATE_ALERT_COCHES')
    : i18n.t('SEARCH_SAVE_NOTIFICATION_ERROR')

  return (
    <SearchSaveNotification
      autoCloseTime={atomToastAutoCloseTimes.long}
      className={className}
      onClose={onClose}
      portalContainer={portalContainer}
      show={show}
      type={
        isMinimumFiltersAppliedError ? SEARCH_SAVE_NOTIFICATION_TYPES.SYSTEM : SEARCH_SAVE_NOTIFICATION_TYPES.WARNING
      }
    >
      {text}
    </SearchSaveNotification>
  )
}

SearchSaveErrorNotification.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  isMinimumFiltersAppliedError: PropTypes.bool,
  portalContainer: typeof Element !== 'undefined' ? PropTypes.instanceOf(Element) : PropTypes.object,
  className: PropTypes.string
}

export default SearchSaveErrorNotification
